export default __webpack_public_path__ + "static/media/pinselwaschtische.c76d6c52.jpg";